// AI Generated Test
import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ElementRef,
    ViewChild,
    AfterViewInit,
    ChangeDetectorRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'form-field-input',
    templateUrl: './form-field-input.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldInputComponent),
            multi: true,
        },
    ],
})
export class FormFieldInputComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    @Input() ngRequired: boolean = false;
    @Input() required = false;
    @Input() label: string = '';
    @Input() helpTxt: string = '';
    @Input() placeholder: string = '';
    @Input() autocomplete: string = '';
    @Input() type: string = 'text';
    @Input() disabled: boolean = false;
    @Input() min: number | string = '';
    @Input() max: number | string = '';
    @Input() httpPrefix: any = '';

    @ViewChild('formGroupRef', { static: true }) formGroupRef!: ElementRef;

    private _value: any = '';
    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _isTouched = false;

    constructor (private elementRef: ElementRef, private cdRef: ChangeDetectorRef) {}

    ngOnInit (): void {
        this.ngRequired = this.ngRequired || false;
        this.type = this.type || 'text';
    }

    ngAfterViewInit (): void {
        // Initialize validation state after view is ready
        this.updateValidationClasses();
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            this._value = val;
            this._onChange(val);
            this._onTouched();
        }
    }

    writeValue (value: any): void {
        if (value !== undefined && value !== null) {
            this._value = value;
            this._onChange(value);
        }
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onValueChange (newValue) {
        if (this.httpPrefix) {
            this.ensureHttpPrefix(newValue);
        } else {
            this.value = newValue;
        }
        this.elementRef.nativeElement.querySelector('input').value = this.value;
        this.updateValidationClasses();
        this.cdRef.detectChanges();
    }

    onInputBlur (): void {
        this._isTouched = true;
        this._onTouched();
        this.updateValidationClasses();
    }

    validateEmail (value: string): boolean {
        if (this.type !== 'email') {
            return true;
        }

        if (!value) {
            return true;
        }

        const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
        return EMAIL_REGEXP.test(value);
    }

    isFieldValid (): boolean {
        if ((this.ngRequired || this.required) && (!this._value || this._value === '')) {
            return false;
        }

        if (this.type === 'email' && this._value) {
            return this.validateEmail(this._value);
        }

        return true;
    }

    public updateValidationClasses (): void {
        if (!this.formGroupRef) {
            return;
        }

        const formGroupElement = this.formGroupRef.nativeElement;
        const isValid = this.isFieldValid();

        if (!isValid && this._isTouched) {
            this.setHasError(formGroupElement);
        } else {
            this.removeHasError(formGroupElement);
        }
    }

    private ensureHttpPrefix (value) {
        if (
            this.value.startsWith('https://') &&
            (
                !value.startsWith('http://') &&
                !value.startsWith('https://')
            )
        ) {
            this.value = 'https://';
            return;
        }

        if (
            this.value.startsWith('http://') &&
            (
                !value.startsWith('http://') &&
                !value.startsWith('https://')
            )
        ) {
            this.value = 'http://';
            return;
        }

        if (value && (!value.startsWith('http://') && !value.startsWith('https://'))) {
            this.value = 'http://' + value;
            return;
        }

        this.value = value;
    }

    private setHasError (formGroupElement: HTMLElement): void {
        if (!formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.add('has-error');
        }
    }

    private removeHasError (formGroupElement: HTMLElement): void {
        if (formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.remove('has-error');
        }
    }
}
